import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useStore } from "../../utils/store";
import HiLifeLogo from "../Icons/HiLifeLogo";

function ForgotPassword() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const setUser = useStore((state) => state.setUser);
  window.localStorage.removeItem("pageStore");

  const handleForgotPassword = (event) => {
    event.preventDefault();

    axios
      .post(
        `${
          process.env.NODE_ENV === "production"
            ? "api"
            : "http://localhost:5533/api"
        }/forgot-password`,
        {
          email: username,
        }
      )
      .then((response) => {
        toast.success("Email zum Passwort zurücksetzen wurde verschickt.");
      })
      .catch((err) => {
        toast.error("E-Mail ist nicht registriert.");
        console.log(err);
      });
  };

  return (
    <div className="bg-beige w-full h-full flex items-center justify-center">
      <Toaster />
      <div className="max-w-md w-full p-5">
        <div className="flex justify-center mb-5 w-32 h-32 mx-auto">
          <HiLifeLogo />
        </div>
        <h1 className="text-2xl font-extrabold text-center mb-3">
          Passwort Vergessen
        </h1>
        <h3 className="login-box-sub text-center font-extrabold mb-8">
          Bitte gib deine Email Adresse an, mit der du dich registriert hast.
        </h3>
        <form onSubmit={handleForgotPassword}>
          <div className="mb-5">
            <label htmlFor="email" className="text-sm">
              E-Mail Adresse
            </label>

            <div className="relative mt-2">
              <input
                type="email"
                className="w-full rounded-lg p-4 text-sm shadow-sm border border-slate-300"
                placeholder="E-Mail Adresse"
                onChange={(e) => setUsername(e.target.value)}
                value={username}
              />
            </div>
          </div>

          <Link
            to={"/register"}
            className="text-pink font-extrabold w-full block mb-7"
          >
            REGISTRIEREN?
          </Link>

          <button
            className="bg-pink w-full block text-white font-extrabold p-4 rounded-full mb-8"
            type="submit"
          >
            ANMELDEN
          </button>

          <p className="text-center">Du hast noch keinen Account?</p>
          <Link
            to={"/register"}
            className="text-pink font-extrabold w-full block text-center"
          >
            JETZT REGISTRIEREN
          </Link>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
